import { combineReducers } from 'redux';
import { ImportCodesReducer } from './ImportCodes/services/reducer';
import { AvailableCodesReducer } from './AvailableCodes/services/reducer';
import { ReceiptsReducer } from './Receipts/services/reducer';
import { SeriesReducer } from './Series/services/reducer';

export const codeBankModuleReducer = combineReducers({
  ImportCodesReducer,
  AvailableCodesReducer,
  ReceiptsReducer,
  SeriesReducer,
});

export type BankModuleReducer = ReturnType<typeof codeBankModuleReducer>;
